/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { HysaBusinessControllerService } from './services/hysa-business-controller.service';
import { CustomFinancingControllerService } from './services/custom-financing-controller.service';
import { CreditCardApplicationControllerService } from './services/credit-card-application-controller.service';
import { BellBankControllerService } from './services/bell-bank-controller.service';
import { WebHookControllerService } from './services/web-hook-controller.service';
import { WealthBoxControllerService } from './services/wealth-box-controller.service';
import { PlaidControllerService } from './services/plaid-controller.service';
import { ApplicationIdentityControllerService } from './services/application-identity-controller.service';
import { UserControllerService } from './services/user-controller.service';
import { SblControllerService } from './services/sbl-controller.service';
import { SageControllerService } from './services/sage-controller.service';
import { MastersControllerService } from './services/masters-controller.service';
import { HelixControllerService } from './services/helix-controller.service';
import { EmailControllerService } from './services/email-controller.service';
import { DueDilligenceControllerService } from './services/due-dilligence-controller.service';
import { DocumentControllerService } from './services/document-controller.service';
import { DashboardControllerService } from './services/dashboard-controller.service';
import { CustomerControllerService } from './services/customer-controller.service';
import { ClientControllerService } from './services/client-controller.service';
import { ClientTermsAcknowledgmentService } from './services/client-terms-acknowledgment.service';
import { BankDocumentControllerService } from './services/bank-document-controller.service';
import { AlloyControllerService } from './services/alloy-controller.service';
import { AdvisorApplicationControllerService } from './services/advisor-application-controller.service';
import { AccountsControllerService } from './services/accounts-controller.service';
import { ReSubmissionControllerService } from './services/re-submission-controller.service';
import { AdvisorFinancingControllerService } from './services/advisor-financing-controller.service';
import { SftpControllerService } from './services/sftp-controller.service';
import { MarketPlaceControllerService } from './services/market-place-controller.service';
import { HealthControllerService } from './services/health-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    HysaBusinessControllerService,
    CustomFinancingControllerService,
    CreditCardApplicationControllerService,
    BellBankControllerService,
    WebHookControllerService,
    WealthBoxControllerService,
    PlaidControllerService,
    ApplicationIdentityControllerService,
    UserControllerService,
    SblControllerService,
    SageControllerService,
    MastersControllerService,
    MarketPlaceControllerService,
    HelixControllerService,
    EmailControllerService,
    DueDilligenceControllerService,
    DocumentControllerService,
    DashboardControllerService,
    CustomerControllerService,
    ClientControllerService,
    ClientTermsAcknowledgmentService,
    BankDocumentControllerService,
    AlloyControllerService,
    AdvisorApplicationControllerService,
    AccountsControllerService,
    ReSubmissionControllerService,
    AdvisorFinancingControllerService,
    SftpControllerService,
    MarketPlaceControllerService,
    HealthControllerService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
